import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { showUpdate, remove, setPaginaAtual } from './grupoFisicoActions';
import SPButton from '../common/form/spButton';
import PermissaoUsuario from '../auth/permissao';

import ReactTableGT2A from '../common/grid/gridReactTable';
import PremiumTableShell from '../common/grid/premiumTableShell';
import swal from 'sweetalert2';

class GrupoFisicoList extends Component {
  constructor(props) {
    super(props);

    this.removerGrupo = this.removerGrupo.bind(this);
  }

  handlePageChange = page => {
    this.props.setPaginaAtual(page);
  };

  removerGrupo(data) {
    swal({
      title: 'Deseja realmente excluir?',
      type: 'question',
      showCancelButton: true,
      confirmButtonColor: 'primary',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      allowOutsideClick: 'false',
    }).then(result => {
      if (result.value) {
        this.props.remove(data);
      }
    });
  }

  render() {
    const grupoFisico = this.props.list || [];
    const paginaAtual = this.props.paginaAtual;

    const columns = [
      {
        Header: 'Ações',
        Cell: row => (
          <div>
            <PermissaoUsuario tela="CadGrupoFisico" condicao={true}>
              <SPButton
                type="button"
                className="warning btn-sm"
                icon="pencil-alt"
                data-title="Alterar"
                onClick={() => this.props.showUpdate(row.original)}
              />
              <SPButton
                type="button"
                className="danger btn-sm"
                icon="trash-alt"
                data-title="Excluir"
                onClick={() => this.removerGrupo(row.original)}
              />
            </PermissaoUsuario>
            <PermissaoUsuario tela="CadGrupoFisico" condicao={false}>
              <SPButton type="button" className="warning btn-sm" icon="pencil-alt" disabled="disabled" />
              <SPButton type="button" className="danger btn-sm" icon="trash-alt" disabled="disabled" />
            </PermissaoUsuario>
          </div>
        ),
        className: 'column_icon',
        width: 90,
        resizable: true,
        Filter: () => (
          <div className="rt-th">
            <span>Filtrar</span>
          </div>
        ),
      },
      {
        Header: 'Código',
        accessor: 'id',
        minWidth: 60,
        maxWidth: 100,
        filterable: true,
        resizable: true,
        className: 'column_grid column_center',
      },
      {
        Header: 'Descrição',
        accessor: 'descricao',
        minWidth: 200,
        className: 'column_grid',
        filterable: true,
        resizable: true,
      },
      {
        Header: 'Ordem',
        accessor: 'ordem',
        minWidth: 60,
        maxWidth: 90,
        className: 'column_grid column_center',
        filterable: true,
        resizable: true,
      },
    ];

    return (
      <div className="table-container" style={{ marginTop: '20px', width: '100%' }}>
        <style>{`
                    .grupo-fisico-premium-table .ReactTable .rt-th.column_center,
                    .grupo-fisico-premium-table .ReactTable .rt-td.column_center {
                        justify-content: center;
                        text-align: center;
                    }

                    .grupo-fisico-premium-table .ReactTable .rt-th.column_grid:not(.column_center),
                    .grupo-fisico-premium-table .ReactTable .rt-td.column_grid:not(.column_center) {
                        justify-content: flex-start;
                        text-align: left;
                    }

                    .grupo-fisico-premium-table .ReactTable .rt-th .rt-resizable-header-content,
                    .grupo-fisico-premium-table .ReactTable .rt-th .rt-th-content {
                        width: 100%;
                        text-align: center;
                        justify-content: center;
                    }

                    .grupo-fisico-premium-table .ReactTable .rt-td,
                    .grupo-fisico-premium-table .ReactTable .rt-th {
                        font-size: 12px;
                    }
                `}</style>

        <div className="grupo-fisico-premium-table">
          <PremiumTableShell summary={`${grupoFisico.length} grupo(s) físico(s) exibido(s)`} tableMinWidth={0}>
            <ReactTableGT2A
              data={grupoFisico}
              columns={columns}
              className="-striped -highlight"
              defaultPageSize={15}
              showPagination
              filterable={true}
              onPageChange={this.handlePageChange}
              page={paginaAtual}
              style={{
                fontSize: '13px',
                width: '100%',
              }}
            />
          </PremiumTableShell>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.grupoFisicoCad.list,
  paginaAtual: state.grupoFisicoCad.paginaAtual,
});
const mapDispatchToProps = dispatch => bindActionCreators({ showUpdate, remove, setPaginaAtual }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GrupoFisicoList);
